module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung-44e6c359a39fd7eb891a4fbfb242b95a.png";